import React, { useReducer, useContext, useEffect } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Customer from './Customer';
import Drivers from './Drivers';
import Transactions from './Transactions';
import { store, initialState, reducer, actions } from './reducer';
import { store as mainStore } from '../../../../../store';
import { useParams } from 'react-router-dom';
import WalletDialog from './WalletDialog';
import CashDialog from './CashDialog';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '& >*:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const GetWaybill = () => {
  useTitle('صدور بارنامه')

  const classes = useStyles();
  const { Provider } = store;
  const { id } = useParams();
  const [state, dispatch] = useReducer(reducer, initialState);
  const {
    payment,
    orderId,
    userId,
    paymentType,
    credit,
  } = state.selectedPayment;
  const { order } = state;
  const { showMessage, showError } = useContext(mainStore);

  const loadPageParameters = async () => {

    try {
      const {
        bidders,
        commissions,
        order,
        transactions,
      } = await actions.fetchingBidders(id);
      dispatch({
        type: 'BIDDERS',
        payload: { bidders, commissions, order, transactions },
      });
    } catch (error) {
      showError(error);
    }
  };

  useEffect(() => {
    loadPageParameters();
  }, [id]);

  return (
    <Provider value={{ state, dispatch, actions, refresh: loadPageParameters }}>
      <WalletDialog
        open={paymentType === 'wallet'}
        orderId={orderId}
        userId={userId}
        payment={payment}
        credit={credit}
      />
      <CashDialog
        open={paymentType === 'cash'}
        orderId={orderId}
        userId={userId}
        payment={payment}
      />
      <FullCard
        title="صدوربارنامه"
        category="در این بخش میتوانید مبالغ پرداختی کمیسیون رانندگان و صاحب بار را مدیریت کنید."
      >
        <div className={classes.root}>
          <Drivers />

          {order?.payType === 'atDestination' ? null : <Customer />}

          <Transactions />
        </div>
      </FullCard>
    </Provider>
  );
};

export default React.memo(GetWaybill);
